import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'

class LevelChart extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'data')) !== JSON.stringify(prevState.data)) {
      let data = get(nextProps, 'data')
      const sortLevel = [
        (item) => {
          const order = {
            'Director': 1,
            'VP': 2,
            'Asst. VP': 3,
            'Manager': 4,
            'Senior Consultant': 5,
            'Consultant': 6,
            'Junior': 7,
            'BOS': 8,
            'Unassigned': 9,
          }
          return order[item.level]
        },
      ]
      data = orderBy(data, sortLevel[0], 'asc')
      const tempLevels = data.filter(level => get(level, 'level') !== '')
      const tempTotal = find(data, { level: 'total' })
      let total = []
      Object.keys(tempTotal).forEach(key => {
        if (key !== 'level') total.push({ label: key, value: tempTotal[key] })
      })
      total = orderBy(total, 'label', 'asc')
      const totalIndex = findIndex(total, { label: 'total' })
      if (totalIndex > -1) {
        const totalValue = total[totalIndex]
        total.splice(totalIndex, 1)
        total.splice(total.length, 0, totalValue)
      }
      const labels = total.map(t => t.label)
      const levels = []
      tempLevels.map(item => {
        let name = ''
        let lobs = []
        Object.keys(item).forEach(key => {
          if (key === 'level') name = item[key]
          else lobs.push({ label: key, value: item[key] })
        })
        lobs = orderBy(lobs, 'label', 'asc')
        const lobIndex = findIndex(lobs, { label: 'total' })
        if (lobIndex > -1) {
          const lobValue = lobs[lobIndex]
          lobs.splice(lobIndex, 1)
          lobs.splice(lobs.length, 0, lobValue)
        }
        levels.push({ label: name, value: lobs })
        return item
      })
      const levelsIndex = findIndex(levels, { label: 'total' })
      if (levelsIndex > -1) {
        const levelValue = levels[levelsIndex]
        levels.splice(levelsIndex, 1)
        levels.splice(total.length, 0, levelValue)
      }
      let levelsPercent = JSON.parse(JSON.stringify(levels))
      levelsPercent = levelsPercent.map(level => {
        const newLevel = level
        newLevel.value = get(level, 'value').map((lob, index) => {
          return get(total, [index, 'value']) !== 0 ? parseFloat((get(lob, 'value') / get(total, [index, 'value'])) * 100).toFixed(2) : '0.00'
        })
        return newLevel
      })
      set(tempState, 'data', data)
      set(tempState, 'total', total)
      set(tempState, 'labels', labels)
      set(tempState, 'levels', levels)
      set(tempState, 'levelsPercent', levelsPercent)
    }
    return tempState
  }

  state={ levelsData: [] }

  componentDidMount() {
    this.forceUpdate()
  }

  renderChart = () => {
    const { labels, levels, levelsPercent } = this.state
    const chart = document.getElementById(get(this.props, 'idchart')).getContext("2d")

    // eslint-disable-next-line no-new
    new Chart(chart, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: "Director",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#F2DC18",
            data: get(levelsPercent, [0, 'value']),
          }, {
            label: "VP",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#FFA600",
            data: get(levelsPercent, [1, 'value']),
          }, {
            label: "Asst. VP",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#FF7C43",
            data: get(levelsPercent, [2, 'value']),
          }, {
            label: "Manager",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#F95D6A",
            data: get(levelsPercent, [3, 'value']),
          }, {
            label: "Senior Consultant",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#D45087",
            data: get(levelsPercent, [4, 'value']),
          }, {
            label: "Consultant",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#A05195",
            data: get(levelsPercent, [5, 'value']),
          }, {
            label: "Junior Consultant",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#665191",
            data: get(levelsPercent, [6, 'value']),
          }, {
            label: "BOS",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#2F4B7C",
            data: get(levelsPercent, [7, 'value']),
          }, {
            label: "Unassigned",
            id: "y-axis-0",
            yAxisID: 'y-axis-0',
            type: "bar",
            backgroundColor: "#003F5C",
            data: get(levelsPercent, [8, 'value']),
          },
        ],
      },
      options: {
        layout: {
          padding: {
            top: 15,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 15,
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        tooltips: {
          mode: 'label',
          callbacks: {
            label: (tooltipItem, data) => {
              const dataIndex = tooltipItem.datasetIndex
              const index = tooltipItem.index
              return `${data.datasets[dataIndex].label}: ${get(levels, [dataIndex, 'value', index, 'value'])} (${data.datasets[dataIndex].data[index]}%)`
            },
          },
        },
        chartArea: {
          backgroundColor: '#EDEFF5',
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [{
            stacked: true,
            position: "left",
            id: "y-axis-0",
            ticks: {
              min: 0,
              max: 100,
              stepSize: 25,
              callback: (value) => {
                return `${value}%`
              },
            },
          }],
        },
      },
    })
  }

  render() {
    if (document.getElementById(get(this.props, 'idchart')) !== null) {
      this.renderChart()
    }
    return (
      <Wrapper>
        <canvas id={ get(this.props, 'idchart') } width='100%' height={ 300 } />
      </Wrapper>
    )
  }
}

export default LevelChart

const Wrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
`



// WEBPACK FOOTER //
// ./src/components/report/charts/headcount/level-chart.js